export default __webpack_public_path__ + "static/Functionalities-e7872042f1051eb1d08c6072f2cf0e25.pdf";